'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _withParams = require('../withParams');

var _withParams2 = _interopRequireDefault(_withParams);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _withParams2.default)({ type: 'required' }, function (value) {
  if (Array.isArray(value)) return !!value.length;

  return value === undefined || value === null ? false : !!String(value).length;
});


//////////////////
// WEBPACK FOOTER
// ./~/vuelidate/lib/validators/required.js
// module id = 273
// module chunks = 0